import { useState, useEffect, useCallback,useMemo } from 'react';
import { getData, addData,updateData,deleteData } from '../../services/seoSchemaMarkupServices';
import { Modal,Button, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import { validateFile} from '../../utils/validators';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { admin_base_url } from '../../config';
import axios from 'axios';


const Seoschemamarkup = () => {
  const [formData, setFormData] = useState({
    id: null,
    uploadedfile: null,
    page_name:'',
    // context_page:'',
    conf_name: '',
    conf_desc: '',
    starting_date: '',
    ending_date: '',
    hotel_name: '',
    street_address: '',
    address_locality: '',
    postal_code: '',
    country: '',
    region: '',
  });
  
  console.log('formData',formData);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  console.log('errors',errors);
  const [dataList, setDataList] = useState([]);
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  // const [pageNameOptions, setPageNameOptions] = useState([
  //   { value: "", label: "Select Page" }
  // ]); 

  // Fetch data from API
  const fetchData = useCallback(async () => {
     setLoading(true);
    try { 
    const response = await getData();
    if (response.data.length > 0) {
      setDataList(response.data);
    }
  }
  catch (error) { 
      console.error('Error fetching data:', error);
    }
  finally {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


   // Validate form data
  const validateForm = () => {
  const newErrors = {};
  if (!formData.conf_name) newErrors.conf_name = "Conference Title is required";
  if (!formData.page_name) newErrors.page_name = "Page name is required";
  // if (!formData.context_page) newErrors.context_page = "Context Page is required";
  if (!formData.conf_desc) newErrors.conf_desc = "Schema description is required";
  if (formData.conf_desc.length < 70 || formData.conf_desc.length > 200) newErrors.conf_desc = "Schema description should be between 70 and 160 characters";
  if (!formData.starting_date) newErrors.starting_date = "Starting date is required";
  if (!formData.ending_date) newErrors.ending_date = "Ending date is required";
  if (!formData.hotel_name) newErrors.hotel_name = "Hotel name is required";
  if (!formData.street_address) newErrors.street_address = "Street address is required";
  if (!formData.address_locality) newErrors.address_locality = "Locality is required";
  if (!formData.postal_code) newErrors.postal_code = "Postal code is required";
  if (!formData.country) newErrors.country = "Country is required";
  if (!formData.region) newErrors.region = "Region is required";
  if (!formData.uploadedfile && formData.uploadedfile === null) {
      if (!errors.uploadedfile) newErrors.uploadedfile = " Schema Image is required";
  }
  setErrors((prev) => ({ ...prev, ...newErrors }));
  return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);  
}

  // Handle input changes
  const handleChange = async(e) => {
    try{
        const { name, value, files } = e.target;
        const file = files?.[0]
          // Create a copy of the current form data
          let updatedData = { ...formData };
          let updatedErrors = { ...errors };
          if (file) {
              const fileType = file.type.includes("image") ? "img" : "pdf";
              const isValid = await validateFile(file, setErrors,name,fileType);
              if (isValid) {
                updatedData[name] = file;
                updatedErrors[name] = '';
              }
              else{
                return ; // Don't update if invalid
              }
        } 
          else{
          updatedData[name] = value;
           // ===> Check if `page_name` already exists in dataList
          if (name === "page_name") {
            const isDuplicate = dataList.some(
              (item) => item.page_name?.toLowerCase() === value.toLowerCase()
            );

            if (isDuplicate) {
              updatedErrors[name] = "Page name already exists";
            } else {
              updatedErrors[name] = ''; // Clear error if unique
            }
          }
          else if (value) {
          updatedErrors[name] = ''; // Clear error if corrected
        }}
        setFormData(updatedData);
        setErrors(updatedErrors);
      }
      catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
        return
      }
    try{
    const form = new FormData();
    form.append('id', formData.id);
    form.append('conf_name', formData.conf_name);
    form.append('page_name', formData.page_name);
    // form.append('context_page', formData.context_page);
    form.append('conf_desc', formData.conf_desc);
    form.append('starting_date', formData.starting_date);
    form.append('ending_date', formData.ending_date);
    form.append('hotel_name', formData.hotel_name);
    form.append('street_address', formData.street_address);
    form.append('address_locality', formData.address_locality);
    form.append('postal_code', formData.postal_code);
    form.append('country', formData.country);
    form.append('postal_code', formData.postal_code);
    form.append('region', formData.region);
    form.append('uploadedfile', formData.uploadedfile);
    if (modalType === 'add') {
        let response = await addData(form);
             if (response.status === 200||201) {
              fetchData();
              setShowModal(false);
                toast.success("Added Successfully!", {
                  position: 'top-right',
                  autoClose: 3000,
                });
              } 
              else{
                  toast.error(response.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
              console.log((response?.message || "Failed to process request."));
              }
            }
      else if (modalType === 'edit') {
          let  response = await updateData(form);
          if (response && response.status === 200) {
            fetchData();  // Re-fetch data after adding/editing
            setShowModal(false);
            toast.success("Updated Successfully!", {position: 'top-right',autoClose: 3000,});
                  }
          else{
          toast.error(response.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
          console.log((response?.message || "Failed to process request."));
           }
          }
  }
  catch (error) {
      console.error("Error in handle submit:", error);
    }
  };


const handleDelete = async () => {
    try{
    if (selectedData) {
      // Optimistically remove the data from the list
      setDataList((prev) => prev.filter((data) => data.id !== selectedData.id));
      // Proceed with the actual delete request
      await deleteData(selectedData.id);
      setShowDeleteConfirmModal(false);
      toast.success("Deleted Successfully!", {position: 'top-right',autoClose: 3000});
    }
  }
  catch (error) {
        console.error('Error deleting data:', error);
      }
  };

  const openModal = (type, data = { id: '', page_name: '',
    // context_page: '', 
    uploadedfile: null,
    conf_name: '',
    conf_desc: '',
    starting_date: '',
    ending_date: '',
    hotel_name: '',
    street_address: '',
    address_locality: '',
    postal_code: '',
    country: '',
    region: ''}) => {
    setModalType(type);
    setFormData(data);
    setShowModal(true);
  };

   const openDeleteConfirmModal = (data) => {
    setSelectedData(data);
    setShowDeleteConfirmModal(true);
  };
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

// Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    const filtered = dataList.filter(
      (data) =>
        data.conf_name.toLowerCase().includes(searchText.toLowerCase()) ||
        data.conf_desc.toLowerCase().includes(searchText.toLowerCase()) 
    );
    const sortedData = [...filtered].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    return sortedData;
  }, [dataList, searchText]);
  
  const columns = [
      {
        name: '#',
        selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
        sortable: false,
        width: '10%',
      },
      {
        name: 'Page name',
        selector: (row) => (<span title={row.page_name}>{row.page_name}</span>),
        sortable: true,
        width: '20%',
      },
      {
        name: 'Conference Name',
        selector: (row) => (<span title={row.conf_name}>{row.conf_name}</span>),
        sortable: true,
        width: '20%',
      },
      {
        name: 'Country',
        selector: (row) => (<span title={row.country}>{row.country}</span>),
        sortable: true,
        width: '20%',
      },

      {
        name: 'Actions',
        cell: (row) => (
          <div>
            <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
            <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)} > Delete </Button>
          </div>
        ),
        width: '25%',
      },
    ];

const cms_private_key = localStorage.getItem('cms_private_key');
const cms_sub_domain = localStorage.getItem('cms_sub_domain');
const admin_api_url = `${admin_base_url}api/admin/metaTags`;

// const getPagenames = async () => {
//   try {
//     const res = await axios.get(admin_api_url, {
//       headers: {
//         cms_private_key: cms_private_key, 
//         cms_sub_domain:cms_sub_domain 
//       }
//     });

//     const options = res.data.data.map((item) => ({
//       value: item.page_value,
//       label: item.page_title
//     }));

//     // Add default option on top
//     setPageNameOptions([
//       { value: "", label: "Select Page" },
//       ...options
//     ]);
//   } catch (error) {
//     console.error("Error fetching meta tags:", error);
//   }
// };

// useEffect(() => {
//     getPagenames();
//   }, []);

const pageNameOptions = [
      { value: "", label: "Select Page" },
      { value: "default", label: "Default" },
      // { value: "about-us", label: "About us" },
      // { value: "brochure", label: "Brochure" },
      // { value: "venue", label: "Venue" },
      // { value: "ocm", label: "OCM" },
      // { value: "program-speakers", label: "Program Speakers" },
      // { value: "registration", label: "Registration" },
      // { value: "submit-abstract", label: "Submit Abstract" },
      // { value: "sessions", label: "Sessions" },
      // { value: "home", label: "Home" },
         ];

const pageContextOptions = [
      { value: "", label: "Select Context Page" },
      { value: "default", label: "Default" },
      { value: "about-us", label: "About us" },
      { value: "brochure", label: "Brochure" },
      { value: "venue", label: "Venue" },
      { value: "ocm", label: "OCM" },
      { value: "program-speakers", label: "Program Speakers" },
      { value: "registration", label: "Registration" },
      { value: "submit-abstract", label: "Submit Abstract" },
      { value: "sessions", label: "Sessions" },
      { value: "home", label: "Home" },
      { value: "terms-and-conditions", label: "Terms and Conditions" },
      { value: "contact-us", label: "Contact us" },
      { value: "webinar-program", label: "Webinar Program" },
      { value: "scientific-program", label: "Scientific Program" },
      { value: "about-webinar", label: "About Webinar" },
      { value: "past-conference", label: "Past Conference" },
      { value: "pc-report", label: "PC Report" },
      { value: "pc-proceedings", label: "PC Proceedings" },
      { value: "pc-attendees", label: "PC Attendees" },
      { value: "pc-testimonials", label: "PC Testimonials" },
      { value: "pc-gallery", label: "PC Gallery" },
      { value: "testimonials", label: "Testimonials" },
      { value: "supporting-journals", label: "Supporting Journals" },
      { value: "media-partners", label: "Media Partners" }
    ];

const customStyles = (hasError) => ({
  control: (provided, state) => ({
    ...provided,
    borderColor: hasError ? '#f5c2c7' : provided.borderColor, // Light red border
    boxShadow: hasError
      ? '0 0 0 1px rgba(167, 16, 31, 0.91)' // Light red outline glow
      : state.isFocused
        ? '0 0 0 1px #2684FF'
        : provided.boxShadow,
    '&:hover': {
      borderColor: hasError ? '#f5c2c7' : provided.borderColor,
    },
  }),
});


  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>SEO Config <b>/ Schema Markup</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>
          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />
          {/* <h1 className="mb-4">Schema Markup</h1> */}

          {/* Editable Form (Always Visible) */}
          {/* <div className="card p-3 mb-4"> */}
            {/* <h4 className='mb-3'>Edit Schema Markup</h4> */}
            <Modal show={showModal} onHide={() => setShowModal(false)} size='lg' backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Form onSubmit={handleSubmit}>
            <div className="row"> 
              <div className="mb-3">
                <label htmlFor="page_name" className="form-label form-label-custom">Page Name <small className='text-danger'> * </small></label>
                <Select
                  id="page_name"
                  name="page_name"
                  value={pageNameOptions.find(opt => opt.value === formData.page_name)}
                  onChange={(selectedOption) =>
                    handleChange({
                      target: {
                        name: 'page_name',
                        value: selectedOption?.value || ''
                      }
                    })
                  }
                  options={pageNameOptions}
                  styles={customStyles(!!errors.page_name)}
                  placeholder="Select Page"
                />
                {errors.page_name && (
                  <div className="invalid-feedback d-block">
                    {errors.page_name}
                  </div>
                )}
              </div>
              {/* <div className="mb-3">
                <label htmlFor="context_page" className="form-label form-label-custom">Context Page<small className='text-danger'> * </small></label>
                <Select
                  id="context_page"
                  name="context_page"
                  value={pageContextOptions.find(opt => opt.value === formData.context_page)}
                  onChange={(selectedOption) =>
                    handleChange({
                      target: {
                        name: 'context_page',
                        value: selectedOption?.value || ''
                      }
                    })
                  }
                  options={pageContextOptions}
                  styles={customStyles(!!errors.context_page)}
                  placeholder="Select Context Page"
                />
                {errors.context_page && (
                  <div className="invalid-feedback d-block">
                    {errors.context_page}
                  </div>
                )}
              </div> */}
              <Form.Group className="col-md-12 mb-3">
              <Form.Label className='form-label-custom'>Conference Title<small className='text-danger'> * </small>Note: <small className='text-info'>Emptying the title will disable Schema Markup on the website</small></Form.Label>
              <Form.Control
                  type="text"
                  name="conf_name"
                  value={formData.conf_name}
                  onChange={handleChange}
                  isInvalid= {!!errors.conf_name}
                />
                <Form.Control.Feedback type="invalid">{errors.conf_name}</Form.Control.Feedback>               
              </Form.Group>

              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Starting Date <small className='text-danger'>*</small></Form.Label>
                <Form.Control
                  type="date"
                  name="starting_date"
                  value={formData.starting_date}
                  onChange={handleChange}
                  isInvalid = {!!errors.starting_date}
                />
                <Form.Control.Feedback type="invalid">{errors.starting_date}</Form.Control.Feedback>               
                
              </Form.Group>
              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Ending Date <small className='text-danger'>*</small> </Form.Label>
                <Form.Control
                  type="date"
                  name="ending_date"
                  value={formData.ending_date}
                  onChange={handleChange}
                  isInvalid = {!!errors.ending_date}
                />
                <Form.Control.Feedback type="invalid">{errors.ending_date}</Form.Control.Feedback>               

              </Form.Group>
              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Hotel Name <small className='text-danger'>*</small></Form.Label>
                <Form.Control
                  type="text"
                  name="hotel_name"
                  value={formData.hotel_name}
                  onChange={handleChange}
                  isInvalid = {!!errors.hotel_name}
                />
                <Form.Control.Feedback type="invalid">{errors.hotel_name}</Form.Control.Feedback>               

              </Form.Group>
              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Street Address <small className='text-danger'>*</small></Form.Label>
                <Form.Control
                  type="text"
                  name="street_address"
                  value={formData.street_address}
                  onChange={handleChange}
                  isInvalid = {!!errors.street_address}
                />
                <Form.Control.Feedback type="invalid">{errors.street_address}</Form.Control.Feedback>               

              </Form.Group>
              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Address Locality <small className='text-danger'>*</small></Form.Label>
                <Form.Control
                  type="text"
                  name="address_locality"
                  value={formData.address_locality}
                  onChange={handleChange}
                  isInvalid = {!!errors.address_locality}
                />
                <Form.Control.Feedback type="invalid">{errors.address_locality}</Form.Control.Feedback>               

              </Form.Group>
              
              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Postal Code <small className='text-danger'>*</small></Form.Label>
                <Form.Control
                  type="text"
                  name="postal_code"
                  value={formData.postal_code}
                  onChange={handleChange}
                  isInvalid = {!!errors.postal_code}
                />
                <Form.Control.Feedback type="invalid">{errors.postal_code}</Form.Control.Feedback>               
              </Form.Group>
             
              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Country <small className='text-danger'>*</small></Form.Label>
                <Form.Control
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  isInvalid = {!!errors.country}
                />
                <Form.Control.Feedback type="invalid">{errors.country}</Form.Control.Feedback>               
              </Form.Group>
                           
              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Region <small className='text-danger'>*</small></Form.Label>
                <Form.Control
                  type="text"
                  name="region"
                  value={formData.region}
                  onChange={handleChange}
                  isInvalid = {!!errors.region}
                />
                <Form.Control.Feedback type="invalid">{errors.region}</Form.Control.Feedback>               

              </Form.Group>

              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Schema Description <small className='text-danger'>*</small> <small className='text-primary'>Char limit: 70-200 | Current char count: {formData.conf_desc.length}</small></Form.Label>
                <Form.Control
                  as="textarea"
                  rows={8} 
                  name="conf_desc"
                  value={formData.conf_desc}
                  onChange={handleChange}
                  isInvalid = {!!errors.conf_desc}
                />
                <Form.Control.Feedback type="invalid">{errors.conf_desc}</Form.Control.Feedback>               
              </Form.Group>
              
              <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Schema Image <small className='text-danger'>*</small> <small className='text-primary'> (Dim: 1980X1080px | Upto: 5MB)</small></Form.Label>
                <Form.Control type="file" name="uploadedfile" onChange={handleChange} 
                  isInvalid = {!!errors.uploadedfile} accept="image/*"/>
                <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>               
                {formData.uploadedfile && typeof formData.uploadedfile === 'string' && (
                    <p>
                    <a href={formData.uploadedfile} target="_blank" rel="noopener noreferrer">
                      View Current File
                    </a>
                  </p>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3">
               {formData.schema_img &&  <Form.Label className='form-label-custom'>Schema Image Preview</Form.Label>}
                {formData.schema_img && (
                  <div style={{height:'200px',width: '200px'}}>
                    <img  src={formData.schema_img} alt="schema preview" width='100%' height='100%'  
                    style={{ objectFit: 'cover' }}
                    crossOrigin="anonymous"
                    />
                  </div>
                )}
                </Form.Group>
              </div>
              {/* <Button variant="success" type="submit">Save</Button> */}
            </Form>
          </Modal.Body>
        <Modal.Footer className='border-0'>
          <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
          <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
        </Modal.Footer>
      </Modal>
      {/* Delete Confirmation Modal */}
        <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to delete this row?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDelete}>
              Yes, Delete
            </Button>
          </Modal.Footer>
        </Modal>
          {/* </div> */}
        </div>
        <Footer />
        </div>
      )}
      </div>
    </div>
  );
};

export default Seoschemamarkup;
